import { styled } from 'twin.macro';

import { flex, size, spacing, position, grid, border } from '../styles';

const Div = styled.div`
  ${flex}
  ${size}
  ${spacing}
  ${position}
  ${grid}
  ${border}

  box-sizing: border-box;
`;

export default Div;
